import { reactive } from "vue";
import packageJson from "../../package.json";
import { axiosNoInterceptors } from "@/axios/axios-config";

export const store = reactive({
  usuarioLogado: false,
  idVendedorLogado: "",
  nomeVendedorLogado: "",
  timeoutAxios: 1000 * 50,
  licencaTeste: false,
  lblDataBloqueio: "",
  mostrouAvisoTeste: false,
  versaoFluxusMobile: packageJson.version,
  versaoFMServidor: "",
  novaVersaoDisponivel: false,
  novidades: [],
  versaoDiferente: false,
  urlBackoffice: localStorage.getItem("fluxus_mobile_urlBackoffice") || "",
  tokenBackoffice: sessionStorage.getItem("fluxus_mobile_tokenBackoffice") || "",
});

export const errosAxios = reactive({
  mensagemErroAxios: "",
  erroAxios: false,
  icon: "pi pi-exclamation-triangle erro",
  header: "Erro na Requisição!",
});

export function alteraMensagemErroAxios(mensagem) {
  errosAxios.mensagemErroAxios = mensagem;
}

export function alteraIconErroAxios(icon) {
  errosAxios.icon = icon;
}

export function alteraHeaderAxios(header) {
  errosAxios.header = header;
}

export function setUrlBackoffice(url) {
  store.urlBackoffice = url;
  localStorage.setItem("fluxus_mobile_urlBackoffice", url);
}

export function setTokenBackoffice(token) {
  store.tokenBackoffice = token;
  sessionStorage.setItem("fluxus_mobile_tokenBackoffice", token);
}

function inicializarAplicacao() {
  const storedUrlBackoffice = localStorage.getItem("fluxus_mobile_urlBackoffice");
  if (storedUrlBackoffice) {
    store.urlBackoffice = storedUrlBackoffice;
  }

  const storedTokenBackoffice = sessionStorage.getItem("fluxus_mobile_tokenBackoffice");
  if (storedTokenBackoffice) {
    store.tokenBackoffice = storedTokenBackoffice;
  }

  if (store.versaoFMServidor === "") {
    consultarVersaoServidor();
  }
}

export async function consultarVersaoServidor() {
  if (store.versaoFMServidor !== "") {
    return;
  }
  try {
    const response = await axiosNoInterceptors.get(`${store.urlBackoffice}/fmVersion`, {
      headers: {
        Authorization: `Bearer ${store.tokenBackoffice}`,
      },
    });
    store.versaoFMServidor = response.data;
    store.versaoDiferente = store.versaoFMServidor !== store.versaoFluxusMobile;
    if (store.versaoDiferente) {
      await consultarDescNovidades();
    }
  } catch (error) {
    // Não faz nada com o erro
  }
}

export async function consultarDescNovidades() {
  try {
    const response = await axiosNoInterceptors.get(
      `${store.urlBackoffice}/fmVersionsFrom?version=${store.versaoFluxusMobile}`,
      {
        headers: {
          Authorization: `Bearer ${store.tokenBackoffice}`,
        },
      }
    );
    store.novidades = response.data;
    if (
      typeof store.novidades === "string" &&
      store.novidades.toLowerCase().startsWith("<!doctype html>")
    ) {
      store.novidades = "";
    }
    await verificarNovidades();
  } catch (error) {
    // Não faz nada com o erro
  }
}

export async function verificarNovidades() {
  try {
    const versaoVista = localStorage.getItem("fluxus_mobile_versao_vista");
    if (versaoVista !== store.versaoFMServidor) {
      store.novaVersaoDisponivel = true;
    } else {
      store.novaVersaoDisponivel = false;
    }
    localStorage.setItem("fluxus_mobile_versao_vista", store.versaoFMServidor);
  } catch (error) {
    // Não faz nada com o erro
  }
}

inicializarAplicacao();
